<template>
  <div id="video-pane">
    <transition name="fade" mode="out-in" appear>
      <div id="videolayer">
        <video :key="videoURL" id="msw_video" autoplay>
          <source :src="videoURL + '.mp4'" type="video/mp4"/>
          <source :src="videoURL + '.mov'" type="video/mov"/>
          <source :src="videoURL + '.webm'" type="video/webm"/>
        </video>
        <button v-on:click="showIntro()">Weiter</button>
      </div>
    </transition>
    
  </div>
</template>

<script>
import eventBus from "../eventBus";

export default {
  name: "msw_video",
  data() {
    return {
      videoURL: ""
    };
  },
  created() {
    this.videoURL = window.dataPath + "video/RUB_MSWiss";
    eventBus.$on("urlChanged", this.clearData);
    var videoElement = document.getElementById("msw_video");
    videoElement.volume = 1.0;
  },
  beforeDestroy() {
    eventBus.$off("urlChanged", this.clearData);
  },
  methods: {
    clearData() {
      this.videoURL = "";
    },
    showIntro() {
      this.$router.replace({ path: "/Intro/1" });
    }
  }
};
</script>

<style lang="scss">
@import "../style/animate.css";
@import "../style/transitions.scss";
@import "../style/basic.scss";

#videolayer {
  height: 100%;

  #msw_video {
    width: calc(100% - 50px);
    height: calc(100% - 200px);
    margin-top: 50px;
    margin-left: 25px;
    margin-right: 25px;
  }

  button {
    position: absolute;
    left: calc(50% - 75px);
    bottom: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Video.vue